import Vue from 'vue'
import io from 'socket.io-client'
import { ACCESS_TOKEN } from '@/store/mutation-types'
import store from '@/store/index'
import { message } from 'ant-design-vue'

export const plvPPTPlayer = {
  liveSdk: null,
  chatRoom: null,
  rtc: null,
  channelId: '',
  userInfo: null,
  async playerPPTInit(channelId, elDom, userInfo, vid) {
    this.channelId = channelId
    const { pptElId, liveElId, chatElId } = elDom
    this.userInfo = userInfo
    const { userId, photo, nickName } = this.userInfo
    const signObj = await Vue.axios.get(`/b/classes/web/stu/schedule/getSign?channelId=${channelId}`)
    const sign = signObj.sign
    const appId = signObj.appId
    const timestamp = signObj.timestamp
    const that = this
    let socket = null
    // 如果有传chatElId，则用保利自带样式
    if (chatElId) {
      const token = Vue.ls.get(ACCESS_TOKEN)
      this.chatRoom = new window.PolyvChatRoom({
        roomId: channelId,
        userId: userId,
        pic: photo,
        nick: nickName,
        container: chatElId,
        width: '100%',
        height: '100%',
        userType: 'slice',
        token: token + new Date().getTime(),
        tabData: [
          {
            name: '互动聊天',
            type: 'chat'
          },
          {
            name: '在线列表',
            type: 'user-list'
          },
          {
            name: '提问',
            type: 'ask'
          },
          {
            name: 'rtc',
            type: 'rtc'
          },
          {
            name: '连麦用户',
            type: 'userlist'
          }
        ],
        roomMessage: function(data) {
          // data为聊天室socket消息，当有聊天室消息时会触发此方法
          console.log(data)
        }
      })
      socket = that.chatRoom.chat.socket
    } else {
      var supportsWebSockets = 'WebSocket' in window || 'MozWebSocket' in window
      this.chatRoom = io.connect('http://chat.polyv.net', {
        query: '',
        transports: [supportsWebSockets ? 'websocket' : 'polling']
      })
      this.initChat()
      socket = this.chatRoom
    }
    this.liveSdk = new window.PolyvLiveSdk({
      channelId: channelId,
      sign: sign, // 频道验证签名
      timestamp: timestamp, // 毫秒级时间戳
      appId: appId, // polyv 后台的appId
      socket: socket,
      user: {
        userId: userId,
        pic: photo,
        nick: nickName
      }
    })
    this.liveSdk.on(window.PolyvLiveSdk.EVENTS.CHANNEL_DATA_INIT, (event, data) => {
      that.liveSdk.setupPlayer({
        pptEl: pptElId,
        el: liveElId,
        autoplay: true,
        type: vid ? 'vod' : 'auto',
        controllerPosition: 'ppt',
        controller: true,
        pptNav: true,
        switchPlayer: true,
        vid: vid || ''
      })
      // that.liveSdk.player.on('switchPlayer', (event, data) => {
      //     console.log('切换ppt和主视频')
      // })
    })

    this.liveSdk.on(window.PolyvLiveSdk.EVENTS.STREAM_UPDATE, function() {
      that.liveSdk.reloadPlayer()
    })
    this.rtc = new window.PolyvRTCWebSDK({
      roomId: channelId,
      socket: socket,
      userId: userId,
      nick: nickName,
      pic: photo
    })
    this.rtc.on('OPEN_MICROPHONE', evt => {
      message.info('讲师开启连麦, 可发起申请加入连麦')
      console.log('讲师开启连麦, 可发起申请加入连麦')
    })

    this.rtc.on('CLOSE_MICROPHONE', evt => {
      console.log('讲师关闭连麦，可禁止发起连麦申请')
    })

    this.rtc.on('ALLOW_MICROPHONE', evt => {
      message.info('连麦申请通过，开始连麦...')
      console.log('连麦申请通过， 开始连麦')
    })

    this.rtc.on('INIT_LOCAL_STREAM_READY', evt => {
      console.log('准备开始推流，设置推流参数')
    })
    this.rtc.on('USER_STREAM_SUBSCRIBED', evt => {
      console.log('订阅成功')
      console.log(`是否为讲师：${evt.teacher}`)
      console.log(`流Id：${evt.streamId}`)
      console.log(`用户昵称：${evt.nick}`)
      console.log(`用户头像：${evt.pic}`)
    })
    this.rtc.on('USER_STREAM_ADDED', evt => {
      console.log(`是否为讲师：${evt.teacher}`)
      console.log(`流Id：${evt.streamId}`)
      console.log(`用户昵称：${evt.nick}`)
      console.log(`用户头像：${evt.pic}`)
    })
  },
  destroy(disconnectSocket = true) {
    this.liveSdk && this.liveSdk.destroy(disconnectSocket)
  },
  initChat() {
    this.connectEvent()
    this.disConnectEvent()
    this.onMessage()
  },
  connectEvent() {
    const _self = this
    this.chatRoom.on('connect', function() {
      _self.login()
    })
  },
  disConnectEvent() {
    const _self = this
    this.chatRoom.on('disconnect', function() {
      if (this.reconnectTimes-- > 0) {
        _self.connectEvent()
      } else {
        console.log('连接失败')
      }
    })
  },
  onMessage() {
    // const that = this
    this.chatRoom.on('message', function(data) {
      var mData = JSON.parse(data)
      store.dispatch('plvPPTPlayer/onMessageEvent', mData)
    })
  },
  login() {
    const { userId, photo, nickName } = this.userInfo
    const param = {
      EVENT: 'LOGIN',
      values: [nickName, photo, userId], // 登录用户信息，不可为空
      roomId: this.channelId, // 当前房间号
      type: 'slice'
    }
    this.sendMsgBase(param)
  },
  sendMsg(msg, isPrivate, userType = '') {
    const param = {
      EVENT: isPrivate ? 'S_QUESTION' : 'SPEAK',
      values: [msg], // 登录用户信息，不可为空
      roomId: this.channelId // 当前房间号
    }
    if (userType) {
      param['type'] = userType // 用户类型，可为空,teacher（教师）、assistant（助教）、manager（管理员）、slice（云课堂学员）
    }
    if (isPrivate) {
      param['content'] = msg
      param['user'] = {
        nick: this.userInfo.nickName,
        pic: this.userInfo.headImgUrl,
        userId: this.userInfo.userId,
        userType: 'slice'
      }
    }

    console.log('param')
    this.sendMsgBase(param)
    // this.chatRoom.emit('message', JSON.stringify({
    //   EVENT: 'SPEAK',
    //   values: [msg],                //发言内容
    //   roomId: this.roomId              //当前房间号
    // }));
  },
  sendMsgBase(param) {
    this.chatRoom.emit('message', JSON.stringify(param))
    // 自己发送的消息，需要手动加上user信息（确保与接收消息的数据格式一致），push到聊天list，
    const message = param
    message['user'] = {
      nick: this.userInfo.nickName,
      pic: this.userInfo.headImgUrl,
      userId: this.userInfo.userId,
      userType: ''
    }
    store.dispatch('plvPPTPlayer/onMessageEvent', message)
  },
  joinChannel() {
    message.info('已申请连麦...')
    this.rtc.joinChannel()
  },
  cancelJoinChannel() {
    this.rtc.cancelJoinChannel()
  },
  async getHistory(NextReqMessageID, size = 20) {
    const res = await Vue.axios.get(
      `http://apichat.polyv.net/front/history?roomId=${
        this.channelId
      }&start=${NextReqMessageID}&end=${NextReqMessageID + size}`,
      { headers: { isClear: true } }
    )
    for (const item of res) {
      store.dispatch('plvPPTPlayer/onMessageEvent', item)
    }
  }
}
